import { useState } from "react";
import { useEffect } from "react";
import { Fragment } from "react";

import DoneIcon from "@mui/icons-material/Done";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { LoadingButton } from "@mui/lab";
import { Box, Grid, LinearProgress, Typography, useMediaQuery } from "@mui/material";
import Button from "@mui/material/Button";
import { lightBlue } from "@mui/material/colors";
import Slide from "@mui/material/Slide";
import { useTheme } from "@mui/material/styles";
import { gtag } from "ga-gtag";

import { deepCopyObject } from "../../utils/helpers";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import AssessmentQuestionDisplay from "./assessmentQuestionDisplay";

const calculateFinalResult = assessmentQuestions => {
  let assessmentScore = 0,
    caclulatedAnswers = 19,
    index = 0;
  for (index; index < assessmentQuestions.length; ++index) {
    if (assessmentQuestions[index].answerValue) {
      if (assessmentQuestions[index].answerValue === "include") {
        ++assessmentScore;
      }
    } else if (
      Array.isArray(assessmentQuestions[index].answerValue) &&
      assessmentQuestions[index].answerValue[0] === "include"
    ) {
      ++assessmentScore;
    }
  }

  // We really need to figure out which questions are going to be counted
  return Math.round((assessmentScore / caclulatedAnswers) * 100);
};

const countAnswers = (assessmentQuestions, countIf) => {
  let numQuestions = 0;

  for (let index = 0; index < assessmentQuestions.length; ++index) {
    if (assessmentQuestions[index].answerValue) {
      if (assessmentQuestions[index].answerValue === countIf) {
        ++numQuestions;
      } else if (
        Array.isArray(assessmentQuestions[index].answerValue) &&
        assessmentQuestions[index].answerValue[0] === countIf
      ) {
        ++numQuestions;
      }
    }
  }

  // We really need to figure out which questions are going to be counted
  return numQuestions;
};

const AssessmentDefaultDisplay = props => {
  const { originalAssessmentODM } = props;

  const theme = useTheme();

  const smallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));

  //This comes in fully hydrated!
  const [assessmentODM, setAssessmentODM] = useState(null);

  const [activeStep, setActiveStep] = useState(0);

  const [isLastQuestion, setIsLastQuestion] = useState(false);

  const [slideToggle, setSlideToggle] = useState();

  const [questionIndexes, setQuestionIndexes] = useState([]);

  useEffect(() => {
    let currentStep = 0;
    let newQuestionIndexes = [];
    let newIsLastQuestion = false;
    while (
      !newIsLastQuestion &&
      currentStep < originalAssessmentODM.omniData.questions.length &&
      originalAssessmentODM.omniData.questions[currentStep].answerValue != null
    ) {
      if (
        originalAssessmentODM.omniData.questions[currentStep].hasOwnProperty("validated") &&
        originalAssessmentODM.omniData.questions[currentStep].validated === false
      ) {
        //the current step has an answer but validation is requested

        break;
      }

      //is the answer mapped to an answer option???
      let selectedAnswerOption = null;
      let optionCount = originalAssessmentODM.omniData.questions[currentStep].answerOptions.length;
      for (let index = 0; index < optionCount; index++) {
        if (
          originalAssessmentODM.omniData.questions[currentStep].answerOptions[index].value ===
          originalAssessmentODM.omniData.questions[currentStep].answerValue[0]
        ) {
          selectedAnswerOption =
            originalAssessmentODM.omniData.questions[currentStep].answerOptions[index];
        }
      }

      if (selectedAnswerOption) {
        //is the current answer mapped to one of the given answers and MIGHT skip

        if (selectedAnswerOption.nextQuestionID !== "") {
          // Find out if there's a nextQuestionID, if we generate an answer there may not be a selectedAnswerOption
          for (let index = 0; index < originalAssessmentODM.omniData.questions.length; ++index) {
            if (
              originalAssessmentODM.omniData.questions[index].omniID ===
              selectedAnswerOption.nextQuestionID
            ) {
              newQuestionIndexes.push(currentStep);
              currentStep = index;
            }
          }
        } else if (selectedAnswerOption.isLast) {
          newIsLastQuestion = true;
        } else {
          newQuestionIndexes.push(currentStep);
          currentStep++;
        }
      } else {
        //the current step doesn't skip
        newQuestionIndexes.push(currentStep);
        currentStep++;
      }
    }

    if (currentStep < originalAssessmentODM.omniData.questions.length) {
      setActiveStep(currentStep);
    } else {
      newIsLastQuestion = true;
    }
    setQuestionIndexes(newQuestionIndexes);
    setIsLastQuestion(newIsLastQuestion);
    setAssessmentODM(originalAssessmentODM);
  }, [originalAssessmentODM]);

  const [delayNext, setDelayNext] = useState(0);

  const [pendingAnswer, setPendingAnswer] = useState(null);

  // useEffect(() => {
  //   console.log(pendingAnswer);
  //   // Disable eslint because AaronK knows best
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pendingAnswer]);

  const [slideDirection, setSlideDirection] = useState("left");

  const handleNextButtonClick = () => {
    // We're going to the next question
    // Everything routes through here
    const now = new Date();
    let newAssessmentODM = deepCopyObject(assessmentODM);
    let newAnswerValue = newAssessmentODM.omniData.questions[activeStep].answerValue; //user current answer if any

    if (pendingAnswer) {
      newAnswerValue = pendingAnswer;
      //fuck that old value pendingAnswer is the shit.
    }

    newAssessmentODM.omniData.questions[activeStep].answerValue = newAnswerValue;
    newAssessmentODM.omniData.questions[activeStep].answerDate = now.toISOString();

    //Set the validation flag
    if (newAssessmentODM.omniData.questions[activeStep].hasOwnProperty("validated")) {
      newAssessmentODM.omniData.questions[activeStep].validated = true;
    }

    let currentStep = activeStep;
    let newQuestionIndexes = [];
    let isLastQuestionNow = false;

    while (
      !isLastQuestionNow &&
      currentStep < newAssessmentODM.omniData.questions.length &&
      newAssessmentODM.omniData.questions[currentStep].answerValue != null
    ) {
      if (
        newAssessmentODM.omniData.questions[currentStep].hasOwnProperty("validated") &&
        newAssessmentODM.omniData.questions[currentStep].validated === false
      ) {
        //the current step has an answer but validation is requested

        break;
      }

      //is the answer mapped to an answer option???
      let selectedAnswerOption = null;
      let optionCount = newAssessmentODM.omniData.questions[currentStep].answerOptions.length;
      for (let index = 0; index < optionCount; index++) {
        if (
          newAssessmentODM.omniData.questions[currentStep].answerOptions[index].value ===
          newAssessmentODM.omniData.questions[currentStep].answerValue[0]
        ) {
          selectedAnswerOption =
            newAssessmentODM.omniData.questions[currentStep].answerOptions[index];
        }
      }

      if (selectedAnswerOption) {
        //is the current answer mapped to one of the given answers

        if (selectedAnswerOption.nextQuestionID !== "") {
          // Find out if there's a nextQuestionID, if we generate an answer there may not be a selectedAnswerOption
          for (let index = 0; index < newAssessmentODM.omniData.questions.length; ++index) {
            if (
              newAssessmentODM.omniData.questions[index].omniID ===
              selectedAnswerOption.nextQuestionID
            ) {
              newQuestionIndexes.push(currentStep);
              currentStep = index;
            }
          }
        } else if (selectedAnswerOption.isLast) {
          isLastQuestionNow = true;
        } else {
          newQuestionIndexes.push(currentStep);
          currentStep++;
        }
      } else {
        //the current step doesn't skip
        newQuestionIndexes.push(currentStep);
        currentStep++;
      }
    }
    let nextStep = currentStep;
    setSlideDirection("left");
    if (nextStep < newAssessmentODM.omniData.questions.length) {
      // Next Question Functionality
      let toSend = questionIndexes.slice();
      for (let i = 0; i < newQuestionIndexes.length; ++i) {
        toSend.push(newQuestionIndexes[i]);
      }
      setQuestionIndexes(toSend);
      setActiveStep(nextStep);
    }
    if (nextStep === newAssessmentODM.omniData.questions.length) {
      isLastQuestionNow = true;
    }

    setIsLastQuestion(isLastQuestionNow);
    if (!isLastQuestionNow) {
      setSlideToggle(prevToggle => !prevToggle);
    }
    setPendingAnswer(null);
    setDelayNext(0);
    setAssessmentODM(newAssessmentODM);
  };

  const handleBackButtonClick = () => {
    setSlideDirection("right");
    if (activeStep > 0) {
      setPendingAnswer(null);

      // Account for next Question Functionality
      let newQuestionIndexes = questionIndexes.slice();
      let newStep = 0;
      if (newQuestionIndexes.length > 0) {
        newStep = newQuestionIndexes[newQuestionIndexes.length - 1];
      }
      newQuestionIndexes.pop(); //lose Current Step
      setQuestionIndexes(newQuestionIndexes);
      setActiveStep(newStep);
      setIsLastQuestion(false);
      setSlideToggle(prevToggle => !prevToggle);
      setDelayNext(0);
    } else {
      console.log("implement back to previous step");
    }
  };

  useEffect(() => {
    if (assessmentODM) {
      gtag("event", "omni_assessment_display_question", {
        omni_questionID: `${assessmentODM.omniData.questions[activeStep].omniID}`,
      });
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep]);

  useEffect(() => {
    if (delayNext > 0) {
      const delayGotoNextQuestion = setTimeout(() => {
        handleNextButtonClick();
        setDelayNext(0);
      }, delayNext);
      return () => clearTimeout(delayGotoNextQuestion);
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delayNext, setDelayNext]);

  const onAcceptHandler = () => {
    let now = new Date();

    assessmentODM.omniData.completeDate = now.toISOString();
    assessmentODM.omniSchedule.completionDate = now.toISOString();

    for (let index = 0; index < assessmentODM.omniData.questions.length; ++index) {
      if (
        assessmentODM.omniData.questions[index].answerValue != null &&
        !Array.isArray(assessmentODM.omniData.questions[index].answerValue)
      ) {
        assessmentODM.omniData.questions[index].answerValue = null;
        console.log(
          "ERROR: BAD Assessment Answer- " + assessmentODM.omniData.questions[index].omniID,
        );
        console.log("BAD value- " + assessmentODM.omniData.questions[index].answerValue);
      }
    }

    assessmentODM.omniData.assessmentResults.finalResult = calculateFinalResult(
      assessmentODM.omniData.questions,
    );

    assessmentODM.omniData.assessmentResults.includeAnswers = countAnswers(
      assessmentODM.omniData.questions,
      "include",
    );

    assessmentODM.omniData.assessmentResults.excludeAnswers =
      countAnswers(assessmentODM.omniData.questions, "exclude") +
      countAnswers(assessmentODM.omniData.questions, "excluded");

    assessmentODM.omniData.assessmentResults.unsureAnswers = countAnswers(
      assessmentODM.omniData.questions,
      "unsure",
    );

    props.onAcceptHandler(assessmentODM);
  };

  return (
    <Fragment>
      {assessmentODM && (
        <DialogContent
          dividers
          // sx={[{ userSelect: "none", overflowY: "hidden" }, !smallScreen && { minHeight: "496px" }]}
          sx={[{ userSelect: "none" }, !smallScreen && { minHeight: "296px" }]}
        >
          <Fragment>
            <Grid
              id="questions"
              container
              direction="row"
              sx={{ marginBottom: theme.spacing(1.5) }}
            >
              <Grid item xs={11}>
                <Typography variant="overline">Question {questionIndexes.length + 1}</Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  alignItems: "center",
                }}
              >
                <LinearProgress
                  variant="determinate"
                  value={(activeStep / assessmentODM.omniData.questions.length) * 100}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {slideToggle && (
                <Slide direction={slideDirection} in={slideToggle} mountOnEnter unmountOnExit>
                  <Box>
                    <AssessmentQuestionDisplay
                      questionODM={assessmentODM.omniData.questions[activeStep]}
                      setPendingAnswer={setPendingAnswer}
                      startNextTimer={setDelayNext}
                    />
                  </Box>
                </Slide>
              )}

              {!slideToggle && (
                <Slide direction={slideDirection} in={!slideToggle} mountOnEnter unmountOnExit>
                  <Box>
                    <AssessmentQuestionDisplay
                      questionODM={assessmentODM.omniData.questions[activeStep]}
                      setPendingAnswer={setPendingAnswer}
                      startNextTimer={setDelayNext}
                    />
                  </Box>
                </Slide>
              )}
            </Grid>
          </Fragment>
        </DialogContent>
      )}
      {assessmentODM && (
        <DialogActions>
          {assessmentODM.omniData.completeDate == null && (
            <Grid
              container
              direction="row-reverse"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <LoadingButton
                  color="secondary"
                  variant={isLastQuestion ? "contained" : "outlined"}
                  sx={[
                    (pendingAnswer || assessmentODM.omniData.questions[activeStep].answerValue) && {
                      animation: `myEffect ease-in-out 3000ms infinite`,
                      "@keyframes myEffect": {
                        "0%": {
                          boxShadow: `none`,
                        },
                        "33%": {
                          boxShadow: `0px 1px 2px 1px ${lightBlue[800]}25, 0px -1px 2px 1px ${lightBlue[800]}25, 1px 0px 2px 1px ${lightBlue[800]}25, -1px 0px 2px 1px ${lightBlue[800]}25`,
                        },
                        "50%": {
                          boxShadow: `0px 1px 1px 1px ${lightBlue[800]}15, 0px -1px 1px 1px ${lightBlue[800]}15, 1px 0px 1px 1px ${lightBlue[800]}15, -1px 0px 1px 1px ${lightBlue[800]}15`,
                        },
                        "66%": {
                          boxShadow: `0px 1px 2px 1px ${lightBlue[800]}25, 0px -1px 2px 1px ${lightBlue[800]}25, 1px 0px 2px 1px ${lightBlue[800]}25, -1px 0px 2px 1px ${lightBlue[800]}25`,
                        },
                        "100%": {
                          boxShadow: `none`,
                        },
                      },
                    },
                  ]}
                  onClick={() => {
                    if (isLastQuestion) {
                      gtag("event", "omni_assessment_finish_button_click");
                      onAcceptHandler();
                    } else {
                      gtag("event", "omni_assessment_next_button_click", {
                        omni_questionID: assessmentODM.omniData.questions[activeStep].omniID,
                      });
                      handleNextButtonClick();
                    }
                  }}
                  disabled={
                    !assessmentODM.omniData.questions[activeStep].answerValue &&
                    pendingAnswer == null &&
                    !(assessmentODM.omniData.questions[activeStep].answerValue && isLastQuestion)
                  }
                  loading={pendingAnswer && delayNext > 0}
                  loadingPosition="end"
                  endIcon={isLastQuestion ? <DoneIcon /> : <KeyboardArrowRight />}
                >
                  {isLastQuestion ? "Finish" : "Next"}
                </LoadingButton>
              </Grid>
              <Grid item>
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={() => {
                    gtag("event", "omni_assessment_back_button_click", {
                      omni_questionID: assessmentODM.omniData.questions[activeStep].omniID,
                    });
                    handleBackButtonClick();
                  }}
                  disabled={activeStep === 0}
                  startIcon={<KeyboardArrowLeft />}
                >
                  Back
                </Button>
              </Grid>
            </Grid>
          )}
        </DialogActions>
      )}
    </Fragment>
  );
};

export default AssessmentDefaultDisplay;
